<script setup lang="ts"></script>

<template>
  <article class="c-references-thumb-skeleton">
    <div class="c-references-thumb-skeleton__image" />

    <div class="c-references-thumb-skeleton__title">
      <div class="sc-skeleton" />
      <div class="sc-skeleton" />
    </div>

    <div class="c-references-thumb-skeleton__description">
      <div class="sc-skeleton" />
      <div class="sc-skeleton" />
      <div class="sc-skeleton" />
      <div class="sc-skeleton" />
    </div>

    <div class="c-references-thumb-skeleton__link">
      <div class="sc-skeleton" />
    </div>
  </article>
</template>

<style lang="scss" scoped>
/* stylelint-disable no-descending-specificity */

@use '@inkline/inkline/css/mixins' as *;
@use '@/assets/styles/mixins/skeleton' as skeleton;

.c-references-thumb-skeleton {
  width: 100%;
  display: flex;
  flex-direction: column;
  border-radius: 2px;
  overflow: hidden;

  .sc-skeleton {
    @include skeleton.skeleton;
  }

  &__image {
    @include skeleton.skeleton;
    width: 100%;
    aspect-ratio: 620 / 480;
    flex: 0 0 auto;
    min-height: 0;
    margin-bottom: 22px;

    @include breakpoint-down('xs') {
      margin-bottom: 16px;
    }
  }

  &__title {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 40px;

    @include breakpoint-down('lg') {
      margin-bottom: 34px;
    }

    @include breakpoint-down('xs') {
      margin-bottom: 26px;
    }

    .sc-skeleton {
      height: 38px;

      @include breakpoint-down('lg') {
        height: 30px;
      }
      @include breakpoint-down('xs') {
        height: 26px;
      }

      &:nth-child(1) {
        width: 92%;
      }
      &:nth-child(2) {
        width: 72%;
      }
    }
  }

  &__description {
    display: flex;
    flex-direction: column;
    gap: 4px;
    margin-bottom: 46px;

    @include breakpoint-down('xs') {
      margin-bottom: 24px;
    }

    .sc-skeleton {
      height: 24px;

      @include breakpoint-down('lg') {
        height: 22px;
      }
      @include breakpoint-down('xs') {
        height: 18px;
      }

      &:nth-child(1) {
        width: 93%;
      }
      &:nth-child(2) {
        width: 72%;
      }
      &:nth-child(3) {
        width: 81%;
      }
      &:nth-child(4) {
        width: 55%;
      }
    }
  }

  &__link {
    display: flex;
    gap: 10px;

    .sc-skeleton {
      width: 32%;
      height: 16px;
    }
  }
}
</style>
